<template>
  <div class="column">
    <div class="box">
      <div v-show="show">
        <a @click="show = !show">
          <img
            :src="require(`../assets/project/${coverImage}`)"
            class="image"
          />
        </a>
        <h3 class="title">{{ title }}</h3>
      </div>

      <div v-show="!show">
        <a
          @click="show = !show"
          class="delete is-warning is-pulled-right is-medium"
        >
        </a>
        <h1 class="title has-text-primary has-text-centered is-flex">
          {{ title }}
        </h1>
        <p>{{ content }}</p>
        <a :href="link" target="_blank" class="has-text-weight-bold">{{
          linkText
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Project",
  props: {
    title: String,
    coverImage: String,
    content: String,
    link: String,
    linkText: String
  },
  data: function() {
    return {
      show: true
    };
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.title {
  padding-top: 1rem;
}
.link {
  padding-top: 1rem;
}
p {
  padding-bottom: 1rem;
}
.delete {
  margin-top: 1.5rem;
}
</style>
